import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import { ADMIN_EMAIL } from "../config/adminConfig";

/**
 * Ruta protegida que requiere autenticación
 * Redirige a /login si no está logueado
 */
export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  // Mientras carga, no renderizar nada para evitar flash
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        background: '#0a0a0f'
      }}>
        <div className="loading-spinner"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

/**
 * Ruta protegida SOLO para administradores
 * Verifica que el usuario esté logueado Y sea el admin autorizado
 * Redirige a / si no tiene permisos
 */
export const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  // Mientras carga, no renderizar nada
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        background: '#0a0a0f'
      }}>
        <div className="loading-spinner"></div>
      </div>
    );
  }
  
  // Verificación estricta: usuario existe, tiene email, y es el admin
  const isAdmin = user && 
                  user.email && 
                  user.email.toLowerCase() === ADMIN_EMAIL.toLowerCase();
  
  if (!isAdmin) {
    // Log de intento de acceso no autorizado (para debugging)
    if (user) {
      console.warn(`[SECURITY] Acceso denegado a ruta admin para: ${user.email}`);
    }
    return <Navigate to="/" replace />;
  }
  
  return children;
};

// Export por defecto el ProtectedRoute para compatibilidad
export default ProtectedRoute;